export default {
    //user
    userId: null,
    username: null,
    table: null,
    userType: undefined,
    
    //functionality
    searchText: '',
    type: 'Food',
    category: 'MainCourse',
    selectedSubCategory: 'All',
    selectedProducts: [],
    productTypes: [],  
    isFood : true,
    isDrink: false,
    clientHeightRow: '100vh',
    
    //order data
    feedbackLeft: false,
    selected_order_status: 'ordered|ready to take over',
    selected_call_status: 'new',


}